// extracted by mini-css-extract-plugin
export default {"container":"login_forgot-module__container--bxMHs","button":"login_forgot-module__button--10Hgb"};